<form [formGroup]="orderAdminForm"
      (keydown.enter)="$event.preventDefault()"
      novalidate>

    <div *ngIf="order" class="card border">

        <div class="card-header warning text-white" tabindex="0" aria-label="Reed Tech Order Delivery">
            Reed Tech Order Delivery
        </div>

        <!--------------------------------
        METADATA XML
        --------------------------------->
        <div class="card-body">
            <div class="row">
                <div class="col-sm-12">
                    <label tabindex="0" aria-label="Metadata XML">
                        Metadata XML
                    </label>
                </div>
            </div>
            <div class="row top-space" *ngIf="metaDataXmlFileName">
                <div class="col-sm-12">
                    <a class="pointer underline" (click)='downloadFile(metaDataXmlFilePath, metaDataXmlFileName)'
                    tabindex="0" aria-label="Metadata XML file" role="link" (keydown.enter)="downloadFile(metaDataXmlFilePath, metaDataXmlFileName)">
                    <i class="fas fa-download" title="Download the file"></i>&nbsp;{{metaDataXmlFileName}}</a>
                </div>
            </div>
            <div class="row" *ngIf="!metaDataXmlFileName">
                <div class="col-sm-12" tabindex="0" aria-label="No Metadata XML file">
                    &nbsp;&nbsp;&nbsp;&nbsp;n/a
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    &nbsp;
                </div>
            </div>

            <!--------------------------------
            ORDER STATUS
            --------------------------------->
            <div class="row">
                <div class="col-sm-12">
                    <label tabindex="0" aria-label="Order status">
                        Order status
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <ejs-dropdownlist #orderStatus
                                      [dataSource]='orderStatusesNoDraft'
                                      tabindex="0"
                                      role="listbox"
                                      aria-label="Select order status"
                                      [fields]='ddwFields'
                                      formControlName="orderStatus">
                    </ejs-dropdownlist>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    &nbsp;
                </div>
            </div>

            <!--------------------------------
            REVISED DUE DATE
            --------------------------------->
            <div class="row">
                <div class="col-sm-12">
                    <label tabindex="0" aria-label="Revised due date">
                        Revised due date
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <ejs-datepicker #confirmedDueDate
                                    formControlName="confirmedDueDate"
                                    tabindex="0"
                                    role="dialog"
                                    aria-label="Due date datepicker"
                                    aria-label="Select order status"
                                    [format]="dateFormat">
                    </ejs-datepicker>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    &nbsp;
                </div>
            </div>

            <!--------------------------------
            DELIVERY FILE
            --------------------------------->
            <div *ngIf="deliveryDoc; else uploaderElseTemplate">
                <!--------------------------------
                DELIVERY FILE - ALREADY UPLOADED
                --------------------------------->
                <div class="row">
                    <div class="col-sm-12">
                        <label tabindex="0" aria-label="Delivery file">
                            Delivery file
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <a class="pointer underline" (click)='downloadFile(deliveryDoc.filePath, deliveryDoc.title)'
                        tabindex="0" role="link" aria-label="download delivery file" (keydown.enter)="downloadFile(deliveryDoc.filePath, deliveryDoc.title)">
                        <i class="fas fa-download" title="Download the file"></i>&nbsp;{{deliveryDoc.title}}</a>

                        <div class="row top-space">
                            <div class="col-12 col-md-6 p-0" *ngIf="((order.sourceDocuments.length && order.sourceDocuments[0].ingestFile) && isScsIngestFileFeatureVisible)"> 
                                <label tabindex="0" aria-label="File ingested">
                                    File ingested
                                </label>
                            </div>
                            <div class="col-12 col-md-6">
                                <div *ngIf="!requestDeletionOfExistingDeliveryDoc">
                                    <!--------------------------------
                                    DELIVERY FILE - ALREADY UPLOADED, NO DELETE REQUESTED
                                    --------------------------------->
                                    <a class="pointer" (click)='deleteExistingDeliveryFile()'
                                    tabindex="0" role="link" aria-label="delete delivery file" (keydown.enter)="deleteExistingDeliveryFile()">
                                        <span class="fas fa-trash-alt" aria-hidden="true"></span>&nbsp;Delete
                                    </a>
                                </div>
                                <div *ngIf="requestDeletionOfExistingDeliveryDoc">
                                    <!--------------------------------
                                    DELIVERY FILE - ALREADY UPLOADED, DELETE REQUESTED
                                    --------------------------------->
                                    <a class="pointer" (click)='undeleteExistingDeliveryFile()'
                                    tabindex="0" role="link" aria-label="undelete delivery file" (keydown.enter)="undeleteExistingDeliveryFile()">
                                        <span class="fas fa-trash-alt text-danger" aria-hidden="true"></span>&nbsp;<span class="text-danger">Will be deleted</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <ng-template #uploaderElseTemplate>
                <!--------------------------------
                DELIVERY FILE - NOT UPLOADED YET
                --------------------------------->
                <div class="row">
                    <div class="col-sm-6">
                        <label tabindex="0" aria-label="Upload delivery file">
                            Upload delivery file
                        </label>
                    </div>
                    <div class="col-12 col-md-6" *ngIf="isScsIngestFileFeatureVisible && (showIngestFile$ | async)"> 
                        <div class="">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" [checked]="ingestFileValue"
                                (change)="onIngestFileChange($event)" (keydown.enter)="onIngestFileChange($event)" aria-labelledby="ingest-file" role="checkbox"
                                aria-label="Checkbox to ingest file" tabindex="0"/>
                                <label class="form-check-label" id="ingest-file">Ingest file</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row top-space">
                    <div class="col-sm-12">
                        <p>
                            <a class="pointer" (click)="browseClick()"
                            tabindex="0" role="link" aria-label="browse delivery file to upload" (keydown.enter)="browseClick()">
                                Browse <i class="fas fa-folder-open" aria-hidden="true"></i>
                            </a>&nbsp;
                        </p>
                        <div>
                            <ejs-uploader #adminFileUpload
                                          id='adminFileUpload'
                                          [autoUpload]='false'
                                          [asyncSettings]='adminFileUploadAsyncSettings'
                                          (selected)='onSelected($event);'
                                          (uploading)='onUploading($event); addCorsHeaders($event);'
                                          (success)='onSuccess($event)'
                                          (actionComplete)='onActionComplete($event)'
                                          (failure)='onUploadFailure($event)'
                                          [allowedExtensions]='adminValidFileExtensionsStr'
                                          [minFileSize]='adminFileMinSize'
                                          [maxFileSize]='adminFileMaxSize'
                                          [multiple]='false'>
                            </ejs-uploader>
                        </div>
                    </div>
                </div>
            </ng-template>

            <!--------------------------------
            DELIVERY FILE - REMIND USERS TO USE MAIN COMPONENT BUTTONS TO SAVE
            --------------------------------->
            <div class="top-space" tabindex="0" aria-label="Save order using update order button">
                <b>Be sure to save the order using the 'Update Order' button.</b>
            </div>

        </div>
    </div>
</form>
